<template>
  <div class="bg-grey-lightest">
    <header class="flex flex-row fixed">
      <div class="header-menu flex-3">
      </div>

      <div class="header-logo flex-1">
        <svg width="300px" height="45px" viewBox="0 0 275 74" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>scaledesk</title>
          <g id="scaledesk" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" font-family="AvenirNext-Bold, Avenir Next" font-size="52" font-weight="bold" letter-spacing="-3">
            <text id="Scale" fill="#1A73E8">
              <tspan x="17" y="54">Scale</tspan>
            </text>
            <text id="Desk" fill="#1A73E8">
              <tspan x="135" y="54">Desk</tspan>
            </text>
          </g>
        </svg>
      </div>
    </header>
    <div class="main-content head-fix-pt flex flex-row">
      <router-view ref="child" />
    </div>
  </div>
</template>

<script>

export default {
};
</script>
